import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';
import Card from '@material-ui/core/Card';
import Avatar from '@material-ui/core/Avatar';
import {
    MuiThemeProvider,
    createMuiTheme,
    withStyles,
} from '@material-ui/core/styles';
import NoSim from '@material-ui/icons/NoSim';

import {defaultTheme, Notification} from 'react-admin';

const styles = theme => ({
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        height: '1px',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    card: {
        minWidth: 300,
        marginTop: '6em',
    },
    avatar: {
        margin: '1em',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        backgroundColor: get(theme, 'pallete.secondary', {500: 'gray'})[500],
    },
    message: {
        backgroundColor: 'rgba(0,0,0,0.7)',
        textAlign: 'center',
        padding: '2rem',
        color: get(theme, 'pallete.primary', {500:'darkGray'})[500]
    }
});

const sanitizeRestProps = ({
                               array,
                               backgroundImage,
                               classes,
                               className,
                               location,
                               staticContext,
                               theme,
                               title,
                               ...rest
                           }) => rest;


class UnstyledNotFound extends Component {
    constructor(props) {
        super(props);
        this.theme = createMuiTheme(props.theme);
        this.containerRef = React.createRef();
        this.backgroundImageLoaded = false;
    }

    // Even though the React doc ensure the ref creation is done before the
    // componentDidMount, it can happen that the ref is set to null until the
    // next render.
    // So, to handle this case the component will now try to load the image on
    // the componentDidMount, but if the ref doesn't exist, it will try again
    // on the following componentDidUpdate. The try will be done only once.
    // @see https://reactjs.org/docs/refs-and-the-dom.html#adding-a-ref-to-a-dom-element
    updateBackgroundImage = (lastTry = false) => {
        if (!this.backgroundImageLoaded && this.containerRef.current) {
            const { backgroundImage } = this.props;
            this.containerRef.current.style.backgroundImage = `url(${backgroundImage})`;
            this.backgroundImageLoaded = true;
        }

        if (lastTry) {
            this.backgroundImageLoaded = true;
        }
    }

    // Load background image asynchronously to speed up time to interactive
    lazyLoadBackgroundImage() {
        const { backgroundImage } = this.props;

        if (backgroundImage) {
            const img = new Image();
            img.onload = this.updateBackgroundImage;
            img.src = backgroundImage;
        }
    }

    componentDidMount() {
        this.lazyLoadBackgroundImage();
    }

    componentDidUpdate() {
        if (!this.backgroundImageLoaded) {
            this.lazyLoadBackgroundImage(true);
        }
    }

    render() {
        const { classes, className, ...rest } = this.props;

        return (
            <MuiThemeProvider theme={this.theme}>
                <div
                    className={classnames(classes.main, className)}
                    {...sanitizeRestProps(rest)}
                    ref={this.containerRef}
                >
                    <Card className={classes.card} style={styles(this.theme).message}>
                        <div className={classes.avatar}>
                            <Avatar className={classes.icon}>
                                <NoSim />
                            </Avatar>
                        </div>
                        <h1>
                            404 Not Found
                        </h1>
                        <p>
                            This is the most awkward "Not Found" page on the internet.
                        </p>
                        <p>
                            Anyway. The resource or page or love or whatever you're looking for isn't here.
                        </p>
                    </Card>
                    <Notification />
                </div>
            </MuiThemeProvider>
        );
    }
}

UnstyledNotFound.propTypes = {
    backgroundImage: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,
    meta: PropTypes.object,
    previousRoute: PropTypes.string,
};

UnstyledNotFound.defaultProps = {
    backgroundImage: 'https://source.unsplash.com/1600x900/daily?desert,road',
    theme: defaultTheme,
};

export const NotFound = withStyles(styles)(UnstyledNotFound);
